import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import CancelIcon from '@material-ui/icons/Cancel';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  },
  iconBackGround:{
    backgroundColor:'#f7941e',
  },
  button:{
    fontSize: 40,
    color: 'white',
    marginTop:-4
  }
}));

export default function FloatingActionButtons(props) {
  const classes = useStyles();

  const handleClose = () => {
    if(props.floatingContactForm === true)
    {
      props.handleFloatingContactForm(false);
    }
    else
    {
      props.handleFloatingContactForm(true);
    }
  };

  return (
    <div className={classes.root}>
      <Fab aria-label="add" className={ classes.iconBackGround } onClick={handleClose}>
        <div className={classes.button}>
        {props.floatingContactForm === true
          ?
          <CancelIcon fontSize={'inherit'}/>
          :
          <QuestionAnswerIcon fontSize={'inherit'}/>
        }
        </div>
      </Fab>
    </div>
  );
}
